/* Discommon Goods footer: single-open accordions + localization auto-submit */
(function () {
	function initFooter(root) {
		if (!root || root.dataset.dgFooterInit === 'true') return;
		root.dataset.dgFooterInit = 'true';

		var headers = root.querySelectorAll('.dg-footer__accordion-header');

		function closeAll(except) {
			headers.forEach(function (h) {
				if (h === except) return;
				h.setAttribute('aria-expanded', 'false');
				var p = document.getElementById(h.getAttribute('aria-controls'));
				if (p) p.hidden = true;
			});
		}

		headers.forEach(function (header) {
			header.addEventListener('click', function () {
				var panel = document.getElementById(header.getAttribute('aria-controls'));
				var isOpen = header.getAttribute('aria-expanded') === 'true';
				closeAll(header);
				header.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
				if (panel) panel.hidden = isOpen;
			});
		});

		root.querySelectorAll('.dg-footer__select select').forEach(function (select) {
			select.addEventListener('change', function () {
				var form = select.closest('form');
				if (form) form.submit();
			});
		});
	}

	function initAll() {
		document.querySelectorAll('.dg-footer').forEach(initFooter);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initAll);
	} else {
		initAll();
	}

	// Theme editor re-renders the section
	document.addEventListener('shopify:section:load', function (event) {
		var root = event.target.querySelector ? event.target.querySelector('.dg-footer') : null;
		if (root) {
			root.dataset.dgFooterInit = 'false';
			initFooter(root);
		}
	});
})();
